import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './AppUserPage.module.css';
import { axiosCms } from 'Axios.js';
import { parseAppUsers } from 'store/reducers/appUser';
import WithError from 'HOC/Error/WithError';
import { fetchAppUsers, updateAppUsers } from 'store/actions/index';
// PageContainer: CSS Grid area <title> and <main>
import * as Page from 'HOC/Layout/PageContainer';
import AppUserTable from 'components/Admin/AppUser/Table/AppUserTable';

const { Container, Title } = Page;

class AppUserPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 0,
      sort: {
        updated_at: 'desc',
        name: 'asc',
      },
    };
  }

  componentDidMount() {
    const { fetchAppUsers } = this.props;
    fetchAppUsers({ status: this.state.status, sort: this.state.sort });
  }

  renderContainer = () => {
    const { parsedAppUsers, isLoading } = this.props;
    return (
      <Container type="2x3">
        <Title title="App Users" />
        <div className={styles.Main}>
          <AppUserTable
            appUsers={parsedAppUsers}
            isLoading={isLoading}
            deleteAdmin={this.deleteAdminHandler}
            updateAdmin={this.updateAdminHandler}
          />
        </div>
      </Container>
    );
  };

  render() {
    return this.renderContainer();
  }
}

const mapStateToProps = state => {
  const { appUsers } = state.appUser;
  console.log(appUsers);
  const parsedAppUsers = parseAppUsers(appUsers);
  const isLoading = state.appUser.loading;

  return {
    parsedAppUsers,
    isLoading,
  };
};

const mapDispatchToProps = { fetchAppUsers, updateAppUsers };

export default connect(mapStateToProps, mapDispatchToProps)(WithError(AppUserPage, axiosCms));



// WEBPACK FOOTER //
// ./src/containers/AppUser/AppUserPage.js